// extracted by mini-css-extract-plugin
var _1 = "PdfViewerToolbarButton-modulePdfViewerToolbarButton__zwwEi";
export { _1 as "PdfViewerToolbarButton" }
